import type { MusicalToken } from '../../types/music';

/** Duración en tiempos (negras en 4/4) → token de silencio canónico. */
export function restTokenFromDurationBeats(durationBeats: number, dotted = false): MusicalToken {
  const beats = dotted ? durationBeats / 1.5 : durationBeats;
  if (beats >= 3.5) return 'R_W';
  if (beats >= 1.75) return 'R_H';
  if (beats >= 0.875) return 'R_Q';
  if (beats >= 0.4375) return 'R_E';
  return 'R_S';
}

export function isRestMusicalToken(token: MusicalToken | string): boolean {
  return typeof token === 'string' && token.startsWith('R_');
}

export function restTokenBeats(token: MusicalToken): number {
  switch (token) {
    case 'R_W':
      return 4;
    case 'R_H':
      return 2;
    case 'R_Q':
      return 1;
    case 'R_E':
      return 0.5;
    case 'R_S':
      return 0.25;
    default:
      return 0;
  }
}

export function keyLabelFromFifths(fifths: number): string {
  if (fifths === 0) return 'Do Mayor / La menor';
  const map: Record<number, string> = {
    1: 'Sol Mayor',
    2: 'Re Mayor',
    3: 'La Mayor',
    4: 'Mi Mayor',
    5: 'Si Mayor',
    6: 'Fa# Mayor',
    '-1': 'Fa Mayor',
    '-2': 'Si bemol Mayor',
    '-3': 'Mi bemol Mayor',
    '-4': 'La bemol Mayor',
    '-5': 'Re bemol Mayor',
    '-6': 'Do bemol Mayor',
  };
  return map[fifths] ?? `Tonalidad (${fifths} quintas)`;
}
